import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { ClientsDebtList } from '@/types/client-debt';
import gaussRound from '@/api/gaussRound';
import REQ_URL from '@/consts/req-url';

@Component({
})
export default class ClientsDebtTable extends Vue {
    search = ''
    xlsLink = REQ_URL.DOWNLOAD_CLIENTS_DEBT
    headers = [
        {
            text: 'Организация',
            value: 'Организация',
            sortable: true,
        },
        {
            text: 'Клиент',
            value: 'Клиент',
            sortable: true,
        },
        {
            text: 'Всего',
            value: 'Всего',
            sortable: true,
        },
        {
            text: 'Доля долга, %',
            value: 'ДоляДолгаПроцент',
            sortable: true,
        },
        {
            text: 'Просрочено',
            value: 'Просрочено',
            sortable: true,
        },
        {
            text: '%',
            value: 'ДоляПросроченоПроцент',
            sortable: true,
            align: 'right'
        },
        {
            text: 'Дней',
            value: 'Дней',
            sortable: true,
        },
        {
            text: 'Наш долг',
            value: 'НашДолг',
            sortable: true,
        },
        {
            text: 'К отгрузке',
            value: 'КОтгрузке',
            sortable: true,
        },
        {
            text: 'Не просрочено',
            value: 'НеПросрочено',
            sortable: true,
        },
        {
            text: 'От 1 до 7 дней',
            value: 'От1До7Дней',
            sortable: true,
        },
        {
            text: 'От 8 до 14 дней',
            value: 'От8До14Дней',
            sortable: true,
        },
        {
            text: 'От 15 до 21 дней',
            value: 'От15До21Дней',
            sortable: true,
        },
        {
            text: 'От 22 до 28 дней',
            value: 'От22До28Дней',
            sortable: true,
        },
        {
            text: 'Свыше 29 дней',
            value: 'Свыше29Дней',
            sortable: true,
        },
        {
            text: 'Дата',
            value: 'ДатаОтчета',
            sortable: false,
            align: 'center'
        }
    ];
    @Prop({ default: () => [] }) clientsDebtList!: ClientsDebtList
    @Prop({ default: true }) loading!: Boolean
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'
    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
    format(num: number) {
        return num ? (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(num) : ''
    }
    total(key: string) {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(this.clientsDebtList.reduce((accumulator, debt) => {
            return gaussRound( accumulator + (debt as any)[key], 2 )
        }, 0))
        
    }
    mounted() { }
}